import {RouteBase} from '../../../app-react/services/routing/route/route-base';

export class LauncherRoute extends RouteBase {
    protected _isOrbitRoute(): boolean {
        return false;
    }

    protected _isMiniOrbitRoute(): boolean {
        return false;
    }
}